import { Icon } from '../components/Icon.tsx';
import { href } from '../router.ts';

export function MasterNav({ current }: { current: 'companies' | 'sites' }) {
  return (
    <nav className="subnav" aria-label="Master data">
      <a href={href.companies()} className={current === 'companies' ? 'on' : ''} aria-current={current === 'companies' ? 'page' : undefined}>
        Companies
      </a>
      <a href={href.sites()} className={current === 'sites' ? 'on' : ''} aria-current={current === 'sites' ? 'page' : undefined}>
        Sites
      </a>
    </nav>
  );
}

export function ReadOnlyBanner({ erpUrl }: { erpUrl?: string | null }) {
  return (
    <div className="banner">
      <Icon name="lock" />
      <span>
        Master data is owned by the <b>EyeQ ERP</b> and is read-only here. It comes from import files until the live ERP feed is promoted (see <a href={href.erpSync()}>ERP Sync</a>); fields with a lock change only through the ERP or a new import.
      </span>
      <span className="sp" />
      {erpUrl && (
        <a className="btn" href={erpUrl} target="_blank" rel="noopener noreferrer">
          <Icon name="ext" />
          Edit in ERP
        </a>
      )}
    </div>
  );
}
